export default function gumletLoader ({ src, width }) {
  const parsedUrl = new URL(src)
  parsedUrl.searchParams.set('w', width)
  return parsedUrl.toString()
}
